class Part {
  constructor({
    id,
    name,
    comment,
    edaMpn,
    footprint,
    normalizedFootprint,
    excluded,
    assignment,
    customerSupplied,
    priceCents,
    availability,
  } = {}) {
    this.id = id;
    this.name = name;
    this.comment = comment;
    this.edaMpn = edaMpn;
    this.footprint = footprint;
    this.normalizedFootprint = normalizedFootprint;
    this.excluded = excluded;
    this.assignment = assignment;
    this.customerSupplied = customerSupplied;
    this.priceCents = priceCents;
    this.availability = availability;
  }

  isSmartMatch() {
    return this.assignment?.type === 'smart_match';
  }

  isPhysicalPart() {
    return this.assignment?.type === 'physical_part';
  }

  isOutOfStock() {
    return this.availability === 'unavailable';
  }

  isProblematic() {
    return this.assignment?.mismatchedFootprint;
  }

  isAutoAssigned() {
    return this.assignment?.assignSource === 'auto';
  }

  // Excluded parts are not placed, so they have no sourcing
  getSourcing() {
    if (this.excluded) return null;
    if (this.customerSupplied) return Part.SOURCING.CUSTOMER;
    return Part.SOURCING.AISLER;
  }

  getStatus() {
    if (this.excluded) return Part.EXCLUDED;
    if (this.isProblematic()) return Part.PROBLEMATIC;
    if (this.isPhysicalPart() && this.customerSupplied) return Part.CUSTOMER_SUPPLIED;
    if (this.isPhysicalPart() || this.isSmartMatch()) {
      if (this.isOutOfStock()) {
        return Part.OUT_OF_STOCK;
      }
      if (this.isAutoAssigned()) {
        return Part.AUTO_ASSIGNED;
      }
      return Part.ASSIGNED;
    }
    return Part.NOT_ASSIGNED;
  }
}

Part.OUT_OF_STOCK = 'OUT_OF_STOCK';
Part.PROBLEMATIC = 'PROBLEMATIC';
Part.NOT_ASSIGNED = 'NOT_ASSIGNED';
Part.ASSIGNED = 'ASSIGNED';
Part.EXCLUDED = 'EXCLUDED';
Part.CUSTOMER_SUPPLIED = 'CUSTOMER_SUPPLIED';
Part.AUTO_ASSIGNED = 'AUTO_ASSIGNED';

Part.STATUS_PRIORITY = {
  [Part.OUT_OF_STOCK]: 0,
  [Part.PROBLEMATIC]: 1,
  [Part.NOT_ASSIGNED]: 2,
  [Part.AUTO_ASSIGNED]: 3,
  [Part.ASSIGNED]: 4,
  [Part.CUSTOMER_SUPPLIED]: 5,
  [Part.EXCLUDED]: 6,
};

Part.SOURCING = {
  AISLER: 'AISLER',
  CUSTOMER: 'CUSTOMER',
};

export default Part;
